/**
 * Neutralise the characters PostgREST's `.or()` filter grammar treats as
 * clause separators / wildcards (`,` `(` `)` `*` `%`) so a free-text search
 * term embeds safely inside an `ilike.%term%` condition. Single source for
 * every admin/catalogue search — deals, users, submissions, requests
 * (previously duplicated inline per module).
 *
 * The special characters are replaced by a SPACE (not stripped) and runs of
 * whitespace are collapsed: "JVC, Marina" → "JVC Marina", never "JVCMarina".
 * Gluing words together silently broke matching (Hani 2026-06-08).
 */
export function escapeIlikeTerm(q: string): string {
  return q
    .replace(/[,()*%]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
